module.exports = __webpack_public_path__ + "static/Dona-Bold-361aed5e178743c5110e18eee2941042.eot";